import { Component, OnInit, Output, EventEmitter, Input } from '@angular/core';

@Component({
  selector: 'app-location-dialog',
  templateUrl: './location-dialog.component.html',
  styleUrls: ['./location-dialog.component.scss']
})
export class LocationDialogComponent implements OnInit {
  @Output() locationSelected = new EventEmitter<string>();
  @Output() closeDialog = new EventEmitter<void>();
  @Output() showOrdersDialog = new EventEmitter<{location: string, isOutpatient: boolean}>();
  @Input() currentLocation: string = 'Office';
  @Input() currentCaseTime: string = '';

  selectedNewLocation: string | null = null;

  inpatientLocations = [
    { name: 'Emergency Department', image: 'assets/emergency.png' },
    { name: 'Intensive Care Unit', image: 'assets/icu.png' },
    { name: 'Inpatient Unit', image: 'assets/ward.png' }
  ];

  outpatientLocations = [
    { name: 'Office', image: 'assets/office.png' },
    { name: 'Home', image: 'assets/home.png' }
  ];

  constructor() {}

  ngOnInit(): void {}

  isLocationDisabled(location: string): boolean {
    return location === this.currentLocation;
  }

  isInpatientLocation(location: string): boolean {
    return this.inpatientLocations.some(loc => loc.name === location);
  }

  selectLocation(location: string): void {
    if (!this.isLocationDisabled(location)) {
      this.selectedNewLocation = location;
    }
  }

  onChangeLocation(): void {
    if (this.selectedNewLocation) {
      const isOutpatient = !this.isInpatientLocation(this.selectedNewLocation);
      this.showOrdersDialog.emit({
        location: this.selectedNewLocation,
        isOutpatient: isOutpatient
      });
      this.closeDialog.emit();
    }
  }

  onClose(): void {
    this.closeDialog.emit();
  }
} 